import { ENV, URL_BFF, URL_GERENCIADOR, URL_MEDICAMENTOS, URL_MEDICAMENTOS_CID } from './../util/constants';
import { MEDICATION } from './../util/data/medication_dispense';
import { IMUNIZATION } from './../util/data/immunization';
import { ENCOUNTER } from './../util/data/encounter';
import { Practicioner } from '../models/practicioner.model';
import { Organization } from '../models/organization.model';
import { DocumentReference } from '../models/documentReference.model';
import { Pacient } from '../models/pacient.model';
import { HOST_EHR, HOST_URL_BFF, HOST_URL_BFF_HMG, ORIGIN } from '../util/constants';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { AuthenticateService } from './authenticate.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Medicamento } from '../models/medicamento.model';

@Injectable({
  providedIn: 'root'
})
export class PacientService {

  constructor(private http: RequestService,
    private auth: AuthenticateService,
    private router: Router) {

  }

  async list(query = '99505976106', currentUser) {
    if (query === '') {
      query = '99505976106';
    }
    return await this.http.get(HOST_EHR + '/api/fhir/r4/Patient' +
      '?identifier=' + encodeURI('http://rnds.saude.gov.br/fhir/r4/NamingSystem/cpf|' + query),
      null, this.getHeaders(currentUser)).then(data => {
        let result = [];
        if (data && data.entry) {
          result = data.entry.map(item => new Pacient(item));
        }
        return result;
      }).catch((error) => {
        return [];
      });
  }

  async getInfo(): Promise<any> {
    const dados = await this.getDadosCadSUSPaciente().then(dados => {
      return dados;
    }).catch(err => {
      console.error(err);

    });

    let jwtDecode: any = await this.auth.getDecodeToken();
    return await this.http.get(HOST_EHR + '/api/fhir/r4/Patient/' + jwtDecode.cnsPaciente,
      null, this.getHeadersUser()).then(async data => {
        data.nomeSocial = dados.nomeSocial;
        let result = new Pacient(data);
        this.listPacient(result);
        return result;
      }).catch((error) => {
        if (error.error && error.error.issue) {
          error.error.issue.forEach(element => {
            this.auth.exceptionMsg(element.diagnostics, 3000);
            this.auth.clearAuthorizationToken();
            this.router.navigateByUrl('/home');
          });
        }
        return [];
      });
  }

  async getDadosCadSUSPaciente() {

    let originContext = localStorage.getItem('originContext');
    const httpOptions = {
      // 'Content-Type': 'application/json',
      // 'Accept': '*/*',
      // 'Accept-Encoding': 'gzip, deflate, br',

      'Authorization': 'Bearer ' + this.auth.getAuthorizationTokenGov(),
      'X-CustomHeader': 'Bearer ' + originContext,
    };

    return await this.http.get(`${URL_GERENCIADOR}v1/usuarios/dados/paciente`, null, httpOptions).catch(err => {

      console.error('====ERROR====', err);
      return {};
    });
  }

  async listPacient(pacient) {
    let valid = true;
    let list: any = await this.auth.getData('_list_patient') || [];
    list.forEach(element => {
      if (element.cns == pacient.cns) {
        valid = false;
      }
    });
    if (valid) {
      list.push(pacient);
      await this.auth.setData(list, '_list_patient');
    }
  }

  async getHistory(userInfo, url?) {
    let jwtDecode: any = await this.auth.getDecodeToken();
    let composition = HOST_EHR + '/api/fhir/r4/Composition?subject=' +
      encodeURI('Patient/' + jwtDecode.cnsPaciente) + '&_sort=-date&_count=10&_include=Composition:subject&_include=Composition:author';
    if (url) {
      composition = url
    }
    let data = await this.http.get(composition, null, this.getHeadersContext());
    let nextPage: any = '';
    let result: any[] = [];
    if (data && data.entry) {
      result = await this.loadEntry(data.entry);
      nextPage = await this.getPagination(data)
    }

    return {
      docs: result,
      next: nextPage,
    };
  }

  async getList(url?, type?, cns?) {
    let jwtDecode: any = await this.auth.getDecodeToken();
    let composition = HOST_EHR + '/api/fhir/r4/List?subject=' +
      encodeURI('Patient/' + jwtDecode.cnsPaciente)
      + '&code=' + encodeURI('http://www.saude.gov.br/fhir/r4/CodeSystem/BRClassificacaoLista|' + type);
    if (url) {
      composition = url
    }
    let data = await this.http.get(composition, null, this.getHeadersContext());
    let nextPage: any = '';
    let result: any[] = [];
    if (data && data.entry) {
      let list = data.entry[0];
      result = await this.loadEntryList(list.resource.entry, type);
      nextPage = await this.getPagination(data)
    }

    return {
      docs: result,
      next: nextPage,
    };
  }

  async getListClear(url?, type?, cns?) {
    try {
      let jwtDecode: any = await this.auth.getDecodeToken();
      let composition = HOST_EHR + '/api/fhir/r4/List?subject=' +
        encodeURI('Patient/' + jwtDecode.cnsPaciente)
        + '&code=' + encodeURI('http://www.saude.gov.br/fhir/r4/CodeSystem/BRClassificacaoLista|' + type);
      if (url) {
        composition = url
      }
      let data = await this.http.get(composition, {}, await this.getHeadersContext());
      let nextPage: any = '';
      let result: any[] = [];
      if (data && data.entry) {
        let list = data.entry[0];
        result = await this.loadEntryList(list.resource.entry, type);
      }

      console.log('vacinas', result);

      return result;
    } catch (e) {
      return []
    }
  }

  async getPagination(data) {
    if (data.link) {
      let item = data.link.find((data) => {
        return data.relation == 'next';
      })
      if (item && item.url) {
        return item.url;
      } else {
        return '';
      }
    }
    return '';
  }

  async loadEntry(data) {
    let result = [];
    for (const item of data) {
      if (item.resource && item.resource.resourceType === 'Composition') {
        let organization, practicionerRole;

        if (item.resource.author) {
          for (const author of item.resource.author) {

            let obj = await this.getReadSystem({
              system: author.identifier.system,
              code: author.identifier.value
            });


            if (author.reference && author.reference.includes('Organization')) {
              organization = author.reference;
            }
            if (author.reference && author.reference.includes('PractitionerRole')) {
              practicionerRole = author.reference;
            }
          }

          let categoria = '';
          if (item.resource.category) {

            let cable = await this.getReadSystem(item.resource.category[0].coding[0]);
            if (cable && cable.parameter) {
              categoria = cable.parameter.find((data) => (data.name == 'display')).valueString;
            }
          }
          const document = new DocumentReference(item.resource, organization, practicionerRole, 'CMD', categoria, item.fullUrl);
          result.push(document);
        }
      }
    }
    return result;
  }

  async loadEntryList(data, type) {
    let result = [];
    if (data) {
      for (const item of data) {
        if (type == 'tests') {
          const document = new DocumentReference({
            id: item.item.reference,
            title: item.flag.coding[0].display,
            date: moment(item.date),
            result: item.item.display,
          }, null, null, 'RESULTADO DE EXAMES');
          result.push(document);
        }
        if (type == 'medications') {
          const document = new DocumentReference({
            id: item.item.reference,
            title: item.flag.coding[0].display,
            date: moment(item.date),
            result: item.item.display,
          }, null, null, 'MEDICAMENTOS');
          result.push(document);
        }
        if (type == 'immunizations') {
          const descVacina = await this.immunoConfig(item.flag);
          const definition = await this.getReadSystem({
            code: item.flag.coding[0].code,
            system: item.flag.coding[0].system
          });
          const detail = await this.getReadFull(item.item.reference + '/$document');
          const manufacture = await this.getManufacture(detail);
          let originCode = '';
          if (detail.reportOrigin) {
            originCode = detail.reportOrigin.coding[0].code;
          }
          const document = new DocumentReference({
            id: item.item.reference,
            title: await this.formatNameCovid(item.flag, descVacina),
            date: (item.date),
            result: item.item.display,
            definition,
            inst: ((descVacina && descVacina.display) ? descVacina.manufacturer : manufacture),
            fab: item.flag.coding[0].code,
            originCode,
          }, null, null, 'welcome');
          result.push(document);
        }
      }
    }
    return result;
  }

  async recuperarMedicamentosRecebidos(ano, mes, tipo, quantidadeRegistros, registroInicial, access_token?) {
    if (this.auth.getAuthorizationToken()) {
      let paramTipo = '';
      if (tipo) {
        paramTipo = '&tipo=' + tipo;
      }
      return this.http.get(`${URL_MEDICAMENTOS_CID}`
        + `?ano=${ano}&mes=${mes}&quantidadeRegistros=${quantidadeRegistros}&registroInicial=${registroInicial}${paramTipo}`, null,
        this.getHeadersUser()).then((result: any) => {
          return result.medicamentos.map(data => new Medicamento(data));
        }).catch((error) => {

          if (ENV === 'DEV') {
            return [
              {
                coDispensacao: 673057767,
                nomeMedicamento: "GLIFAGE XR",
                nomeUnidadeDispensacao: "DROGARIA ROSARIO S/A",
                dataRetirada: "08/07/2016 12:35:52",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 5,40",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 10,80",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 654481724,
                nomeMedicamento: "CLORIDRATO DE METFORMINA",
                nomeUnidadeDispensacao: "DROGARIA E PERFUMARIA MIX LTDA - EPP",
                dataRetirada: "26/05/2016 19:26:12",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 5,40",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 10,80",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 654481400,
                nomeMedicamento: "LOSARTANA POTÁSSICA",
                nomeUnidadeDispensacao: "DROGARIA LEONEL LTDA - EPP",
                dataRetirada: "26/05/2016 19:17:23",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 9,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 18,00",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 638571334,
                nomeMedicamento: "GLIFAGE XR",
                nomeUnidadeDispensacao: "DROGARIA SAO PAULO S.A.",
                dataRetirada: "18/04/2016 19:01:52",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 3,60",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 7,20",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 638573365,
                nomeMedicamento: "AEROLIN",
                nomeUnidadeDispensacao: "DROGARIA SAO PAULO S.A.",
                dataRetirada: "18/04/2016 19:00:34",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 20,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 20,00",
                qtdDispensada: 200,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 626578247,
                nomeMedicamento: "ZART",
                nomeUnidadeDispensacao: "DROGASIL SA",
                dataRetirada: "21/03/2016 10:15:23",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 9,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 18,00",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 556680783,
                nomeMedicamento: "AEROLIN",
                nomeUnidadeDispensacao: "DROGARIA LEONEL LTDA - EPP",
                dataRetirada: "26/09/2015 18:52:52",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 20,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 20,00",
                qtdDispensada: 200,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 541162126,
                nomeMedicamento: "AEROLIN",
                nomeUnidadeDispensacao: "DROGARIA ROSARIO S/A",
                dataRetirada: "18/08/2015 17:10:11",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 20,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 20,00",
                qtdDispensada: 200,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 526305133,
                nomeMedicamento: "AEROLIN",
                nomeUnidadeDispensacao: "DROGARIA ROSARIO S/A",
                dataRetirada: "11/07/2015 16:56:35",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 20,00",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 20,00",
                qtdDispensada: 200,
                tpDispensacao: "Gratuito",
              },
              {
                coDispensacao: 508989961,
                nomeMedicamento: "VALTRIAN",
                nomeUnidadeDispensacao: "DROGARIA ROSARIO S/A",
                dataRetirada: "29/05/2015 11:51:07",
                ufRetirada: "DF",
                municipio: "BRASILIA",
                vlTotal: "R$ 9,60",
                vlCidadao: "R$ 0,00",
                vlMinstSaude: "R$ 19,20",
                qtdDispensada: 60,
                tpDispensacao: "Gratuito",
              },
            ];
          }
          return [];
        });
    } else {
      return [];
    }
  }

  async urlExists(url) {
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return http.status != 404;
  }

  async getRead(reference) {
    return await this.http.get(HOST_EHR + '/api/fhir/r4/' + reference,
      null, this.getHeadersUser()).then(data => {
        return data;
      }).catch((error) => {
        return [];
      });
  }


  async getContentFile(reference) {
    return await this.http.get(HOST_EHR + '/api/fhir/r4/' + reference,
      null, this.getHeadersUser()).then(data => {
        return data;
      }).catch((error) => {
        return [];
      });
  }

  async getReadSystem(reference) {
    return await this.http.get(HOST_EHR + '/api/fhir/r4/CodeSystem/$lookup?system=' + reference.system + '&code=' + reference.code,
      null, this.getHeadersUser(false)).then(data => {
        return data;
      }).catch((error) => {
        if (error.error && error.error.issue) {
          return [];
        }
        return [];
      });
  }

  async read(data) {
    return new Promise((resolve, reject) => {
      const myHeaders = new Headers();
      myHeaders.append('Authorization', 'Basic ' + this.auth.getAuthorizationToken());
      myHeaders.append('Content-Type', 'text/plain');
      const requestOptions: any = {
        method: 'POST',
        headers: myHeaders,
        body: data,
        redirect: 'follow'
      };

      fetch(URL_BFF + '/api/signToken/validate', requestOptions)
        .then(response => {
          resolve(response.ok ? response.json() : null)
        })
        .catch((error) => {
          resolve(null);
        });
    });
  }

  async getDadosCertificadoCovid() {
    const server = JSON.parse(localStorage.getItem('app_icp_token'));
    const token = this.auth.getAuthorizationToken();
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };

    const jwtDecode = await this.auth.getDecodeToken();
    return this.http.get(URL_BFF + '/api/vacinacao/certificado/covid/' + jwtDecode.cnsPaciente + '/dados',
      null, httpOptions).then(data => {
        return data;
      }).catch((error) => {
        return false;
      });
  }

  async getDadosCertificadoCovidUk() {

    const server = JSON.parse(localStorage.getItem('app_icp_token'));
    const token = this.auth.getAuthorizationToken();
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };
    const jwtDecode = await this.auth.getDecodeToken();
    return this.http.get(URL_BFF + '/api/vacinacao/certificado/eudcc/' + jwtDecode.cnsPaciente + '/dados',
      null, httpOptions).then(data => {
        return data;
      }).catch((error) => {
        return false;
      });
  }

  getHeaders(currentUser) {
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Cnes': '2004488',
      'Authorization': '709805016469793',
      //'Authorization-Practitioner': currentUser.cpf.replace(/[\(\)\.\s-]+/g,''),
    };

    return httpOptions;
  }


  getHeadersUser(gov = true) {

    let server = JSON.parse(localStorage.getItem('app_icp_token'));
    let token = this.auth.getAuthorizationTokenGov();
    if (!token || !gov) {
      token = this.auth.getAuthorizationToken()
    }
    const httpOptions = {
      'Content-Type': 'application/json',
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };

    return httpOptions;
  }

  getHeadersContext() {
    let server = JSON.parse(localStorage.getItem('app_icp_token'));
    const httpOptions = {
      'Content-Type': 'application/json',
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + this.auth.getAuthorizationToken(),
    };

    return httpOptions;
  }

  getHeadersContextText() {
    let server = JSON.parse(localStorage.getItem('app_icp_token'));
    const httpOptions = {
      'Content-Type': 'text/plain',
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + this.auth.getAuthorizationTokenGov(),
    };

    return httpOptions;
  }

  async vacinasAprazadas(cnsC?) {
    try {
      let jwtDecode = await this.auth.getUserData();
      let cns = jwtDecode.cns;
      let composition = HOST_URL_BFF_HMG + '/api/aprazamento?cns=' + cns;
      let data = await this.http.get(composition, {}, await this.getHeadersUser());
      return data;
    } catch (e) {
      return []
    }
  }

  async getIntegrationContext() {

    this.router.navigateByUrl('/home/pacient');
    /*let contexto = localStorage.getItem('originContext');
    let token =  await this.http.postDirectText(HOST_EHR + '/api/autenticar-contexto',
      contexto
      , this.getHeadersContextText()).then(data => {
          return data;
      }).catch((error) => {
          console.log('error--------', error)
          if (error.error) {
              return JSON.parse(error.error);
          } else {
              return null;
          }
      });

      if (token.messages) {
          this.auth.exceptionMsgCenter(token.messages[0], 0);
      } else {
          await this.auth.resetAuthorizationToken(token);
          this.router.navigateByUrl('/home/pacient');
      }*/
  }

  async urlCaderneta(language?) {
    const jwtDecode: any = await this.auth.getDecodeToken();
    return URL_BFF + '/api/vacinacao/certificado/cidadao/' + jwtDecode.cnsPaciente + '/exportar/pdf?lang=' + language;
  }

  async immunoConfig(flag) {
    try {
      const jwtDecode = this.auth.getUserData();
      const cns = jwtDecode.cns;
      const composition = URL_BFF + '/api/imunocfg/get?code=' + flag.coding[0].code + '&system=' + flag.coding[0].system;
      return await this.http.get(composition, {}, await this.getHeadersUser(false));
    } catch (e) {
      return false;
    }
  }

  async getReadFull(reference) {
    return this.http.get(reference,
      null, await this.getHeadersUser(false)).then(data => {
        return data;
      }).catch((error) => {
        if (error.error && error.error.issue) {
          return false;
        }
        return false;
      });
  }

  async getManufacture(detail) {
    let manufacture = '';
    if (detail && detail.entry) {
      for (const data of detail.entry) {
        if (data.resource.resourceType == 'Immunization') {
          if (data.resource.manufacturer && data.resource.manufacturer.identifier) {
            const params = await this.getReadSystem({
              system: data.resource.manufacturer.identifier.system,
              code: data.resource.manufacturer.identifier.value
            });
            if (params && params.parameter) {
              manufacture = params.parameter.find((dataSys) => (dataSys.name == 'display')).valueString;
            }
          }
        }
      }
      return manufacture;
    }
  }

  async formatNameCovid(flag, descVacina) {
    let params = flag.coding[0].display;
    if (descVacina.display) {
      params = descVacina.display;
    }
    return params;
  }
}
